import { render, staticRenderFns } from "./Detect.vue?vue&type=template&id=37e4f460&scoped=true"
import script from "./Detect.vue?vue&type=script&lang=js"
export * from "./Detect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4f460",
  null
  
)

export default component.exports